import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/landing.css';
import PublicNav from '../../components/public/PublicNav';
import PublicFooter from '../../components/public/PublicFooter';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Welcome() {
  const q = useQuery();
  const checkout = q.get('checkout');
  const paid = checkout === 'success';
  const cancelled = checkout === 'cancelled';

  return (
    <div className="lp-root">
      <PublicNav />
      <main className="welcome">
        <div className="welcome__card">
          <p className="lp-eyebrow">You’re in</p>
          <h1>
            {cancelled
              ? 'Checkout cancelled'
              : paid
                ? 'Payment received'
                : 'Request received'}
          </h1>
          <p className="welcome__lead">
            {cancelled
              ? 'No charge was made. You can pick a plan again anytime.'
              : 'Here’s what happens next — admin setup first, then you run skills.'}
          </p>

          {!cancelled && (
            <ol className="welcome__steps">
              <li>
                <strong>We review your plan request</strong>
                <span>An admin confirms your signup and workspace.</span>
              </li>
              <li>
                <strong>You get login access</strong>
                <span>We’ll email credentials (or your admin creates your user).</span>
              </li>
              <li>
                <strong>Run a skill</strong>
                <span>Sign in → Run a skill → describe work → see output on Tasks, Slack, and Plane.</span>
              </li>
            </ol>
          )}

          <div className="welcome__actions">
            {cancelled ? (
              <Link to="/pricing" className="lp-btn lp-btn--primary lp-btn--lg">
                Back to pricing
              </Link>
            ) : (
              <Link to="/login" className="lp-btn lp-btn--primary lp-btn--lg">
                Sign in when ready
              </Link>
            )}
            <Link to="/" className="lp-btn lp-btn--ghost lp-btn--lg">
              Back to homepage
            </Link>
          </div>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
